/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIAgentTracesSortCriteria {
    getFixupPrototypeFunction() { return AIAgentTracesSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AIAgentTracesSortCriteria>): AIAgentTracesSortCriteria {
        let obj = Object.assign(new AIAgentTracesSortCriteria(), model);
        AIAgentTracesSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIAgentTracesSortCriteria>): AIAgentTracesSortCriteria {
        if (!model) return null;
        return AIAgentTracesSortCriteria.newInstance(<AIAgentTracesSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIAgentTracesSortCriteria) {
        if (!obj) return;

        models.AIAgentTracesSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIAgentTracesSortCriteria): boolean {
        Object.setPrototypeOf(obj, AIAgentTracesSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AIAgentTracesSortColumn;

    ascending: boolean;

}
